export const formList = [
  'login',
  'register',
  'customer',
  'invoice',
  'expense',
  'allowance',
  'decisionDialog',
  'profile',
  'tax',
  'yel',
  'password',
  'resetPassword',
  'adminSearchCustomer',
  'adminSearchInvoice'
]
